import { createFileRoute, redirect, useRouter } from "@tanstack/react-router";
import { z } from "zod";
import { ResetPasswordForm } from "@/components/features/ResetPassword/ResetPasswordForm";
import { isAuthenticated } from "@/utils/authHelpers";

const resetPasswordSearchSchema = z.object({
  token: z.string().optional(),
});

export const Route = createFileRoute("/_unauthenticated/reset-password/")({
  validateSearch: resetPasswordSearchSchema.parse,
  beforeLoad: async ({ search }) => {
    if (isAuthenticated()) {
      throw redirect({ to: "/" });
    }
    if (!search.token) {
      throw redirect({ to: "/reset-link-expiry", search: { state: "expired" } });
    }
  },
  component: ResetPasswordRouteComponent,
});

function ResetPasswordRouteComponent() {
  const { navigate } = useRouter();
  const { token } = Route.useSearch();

  return (
    <ResetPasswordForm
      token={token as string}
      onLinkInvalid={() => navigate({ to: "/reset-link-expiry", search: { state: "expired" } })}
      onSuccess={() =>
        navigate({
          to: "/login",
          search: {
            status: "reset-success",
            message: "Password reset successful. Please log in with your new password.",
          },
        })
      }
    />
  );
}
